import * as components from '../components/index';
export const router = (app) => {
    for (const key in components) {
        app.component(key, components[key]);
    }
};
